import { createContext, useContext } from "react";
import type { Tab } from "./TabsContext.types";

// Aba em que a página está renderizando.
// null = página veio pelo <Outlet/> da rota, não de uma aba.
const CurrentTabContext = createContext<Tab | null>(null);

export const CurrentTabProvider = CurrentTabContext.Provider;

export function useCurrentTabId(): string | null {
  return useContext(CurrentTabContext)?.id ?? null;
}

// Código de operação (_OP) que o item de menu pediu ao abrir esta aba — ver menuTree.ts,
// useTabInitialAction.
export function useCurrentTabInitialAction(): string | undefined {
  return useContext(CurrentTabContext)?.initialAction;
}
